import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function TermsOfServiceIT() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-indigo-100">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center text-indigo-600 hover:text-indigo-700 mb-6 transition-colors duration-200"
        >
          <ArrowLeft className="mr-2 h-5 w-5" />
          Torna all'applicazione
        </button>

        <article className="bg-white rounded-lg shadow-xl p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Termini di Servizio</h1>

          <div className="space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">
              Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Informazioni sull'Azienda</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Simple Stickers è gestito da <span className="font-semibold">Puretech s.r.o.</span>,
                  una <span className="font-semibold">società a responsabilità limitata</span> costituita secondo le leggi della <span className="font-semibold">Repubblica Ceca</span>.
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm font-medium text-gray-700 mb-2">Dettagli dell'Azienda:</p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li><strong>Numero di Identificazione (IČO):</strong> 05503795</li>
                    <li><strong>Stato IVA:</strong> Non soggetto</li>
                    <li><strong>Indirizzo dell'Ufficio:</strong> Heydukova 1035, 54401 Dvůr Králové nad Labem, Repubblica Ceca</li>
                    <li><strong>Email:</strong> support@simplestickers.app</li>
                    <li><strong>Sito Web:</strong> <a href="https://www.simplestickers.app" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-800 hover:underline">www.simplestickers.app</a></li>
                    <li><strong>Rappresentata da:</strong> Pavel Vlček</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Accettazione dei Termini</h2>
              <p className="leading-relaxed">
                Accedendo e utilizzando Simple Stickers ("il Servizio"), accetti e accetti di essere vincolato ai termini e alle disposizioni di questo accordo. Se non sei d'accordo con quanto sopra, ti preghiamo di non utilizzare questo servizio.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Descrizione del Servizio</h2>
              <p className="leading-relaxed">
                Simple Stickers è un'applicazione di gestione di attività e progetti che fornisce agli utenti strumenti per organizzare note adesive utilizzando un sistema di bacheca in stile Kanban. Il servizio include livelli gratuiti e premium con diversi set di funzionalità e limiti di utilizzo.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Account Utente</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Sei responsabile del mantenimento della riservatezza del tuo account e password e della limitazione dell'accesso al tuo computer. Accetti di assumerti la responsabilità per tutte le attività che si verificano sotto il tuo account o password.
                </p>
                <p className="leading-relaxed">
                  Devi fornire informazioni accurate e complete durante la creazione del tuo account e mantenere queste informazioni aggiornate.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Abbonamento e Termini di Pagamento</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Livello Gratuito:</strong> Include l'accesso alle funzionalità di base con limitazioni sul numero di note adesive (50) e suggerimenti AI (10 al giorno).
                </p>
                <p className="leading-relaxed">
                  <strong>Livello Premium:</strong> Disponibile per $48 all'anno, include limiti aumentati (1000 note adesive, 100 suggerimenti AI al giorno) e funzionalità aggiuntive come le capacità di condivisione delle note adesive.
                </p>
                <p className="leading-relaxed">
                  L'elaborazione dei pagamenti è gestita da Polar. Gli abbonamenti si rinnovano automaticamente a meno che non vengano cancellati. Puoi cancellare il tuo abbonamento in qualsiasi momento tramite le impostazioni del tuo account.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Uso Accettabile</h2>
              <p className="leading-relaxed">
                Accetti di non utilizzare il servizio per archiviare, trasmettere o distribuire contenuti illegali, dannosi, minacciosi, abusivi, molesti, diffamatori, volgari, osceni o altrimenti discutibili. Accetti inoltre di non interferire con il servizio o tentare di accedere ad account appartenenti ad altri.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Privacy e Protezione dei Dati Personali</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  La tua privacy è importante per noi. Per i dettagli su come raccogliamo, utilizziamo e proteggiamo le tue informazioni personali, consulta la nostra <a href="/privacy-policy" className="text-indigo-600 hover:text-indigo-800 hover:underline font-medium">Informativa sulla Privacy</a>.
                </p>
                <p className="leading-relaxed">
                  Utilizzando questo servizio, accetti anche la nostra Informativa sulla Privacy e il trattamento dei tuoi dati personali in conformità con il GDPR e le leggi applicabili sulla protezione dei dati.
                </p>
                <p className="leading-relaxed">
                  Per esercitare i tuoi diritti ai sensi del GDPR o per richieste sulla protezione dei dati, contattaci a <strong>support@simplestickers.app</strong>.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Disponibilità del Servizio e Supporto</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Disponibilità del Servizio:</strong> Ci impegniamo per la massima disponibilità del servizio e un funzionamento affidabile. In caso di interruzioni non pianificate, lavoriamo per risolverle prontamente. Il servizio è fornito "così com'è" senza garanzie formali di disponibilità.
                </p>
                <p className="leading-relaxed">
                  <strong>Manutenzione:</strong> Per garantire sicurezza e stabilità, potremmo eseguire manutenzione continua del servizio. Cerchiamo di programmare la manutenzione pianificata durante i periodi di basso utilizzo e fornire preavviso quando possibile. In casi urgenti (ad es. patch di sicurezza), la manutenzione può verificarsi senza preavviso.
                </p>
                <p className="leading-relaxed">
                  <strong>Supporto:</strong> Offriamo supporto tecnico via email a support@simplestickers.app. Ci impegniamo a rispondere il più rapidamente possibile, tuttavia tempi di risposta specifici non sono garantiti.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Politica di Rimborso</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Garanzia di Rimborso di 30 Giorni:</strong> Se non sei soddisfatto del servizio premium, puoi richiedere un rimborso completo entro 30 giorni dal tuo acquisto iniziale. Dopo 30 giorni, tutti i pagamenti sono definitivi e non rimborsabili.
                </p>
                <p className="leading-relaxed">
                  <strong>Errori di Fatturazione:</strong> Se ritieni di essere stato addebitato in modo errato, contattaci a support@simplestickers.app entro 30 giorni dall'addebito.
                </p>
                <p className="leading-relaxed">
                  <strong>Elaborazione dei Rimborsi:</strong> I rimborsi approvati verranno elaborati entro 10-14 giorni lavorativi al metodo di pagamento originale. Ci riserviamo il diritto di approvare o negare le richieste di rimborso a nostra esclusiva discrezione.
                </p>
                <p className="text-sm text-gray-600">
                  Nota: Le cancellazioni di abbonamento non comportano automaticamente rimborsi. Devi richiedere esplicitamente un rimborso entro il periodo di 30 giorni.
                </p>
              </div>
            </section>
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Restrizioni di Età ed Eleggibilità</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Età Minima:</strong> Devi avere almeno 16 anni per utilizzare questo servizio.
                </p>
                <p className="leading-relaxed">
                  <strong>Consenso Genitoriale:</strong> Gli utenti di età inferiore ai 18 anni devono avere il consenso di un genitore o tutore per utilizzare il servizio.
                </p>
                <p className="leading-relaxed">
                  <strong>Utenti Aziendali:</strong> Gli account aziendali richiedono che l'utente abbia l'autorità di vincolare l'organizzazione.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Legge Applicabile e Giurisdizione</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Questi Termini saranno regolati e interpretati in conformità con le leggi della Repubblica Ceca, senza riguardo alle sue disposizioni sui conflitti di legge.
                </p>
                <p className="leading-relaxed">
                  Qualsiasi controversia derivante da questi Termini o dal tuo utilizzo del Servizio sarà soggetta alla giurisdizione esclusiva dei tribunali della Repubblica Ceca.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Moderazione dei Contenuti</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Ci riserviamo il diritto di rimuovere, modificare o rifiutare di visualizzare qualsiasi contenuto che violi questi Termini o che riteniamo inappropriato, a nostra esclusiva discrezione.
                </p>
                <p className="leading-relaxed">
                  Se ritieni che un contenuto debba essere esaminato, contattaci a support@simplestickers.app.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Proprietà Intellettuale</h2>
              <p className="leading-relaxed">
                Il servizio e il suo contenuto originale, caratteristiche e funzionalità sono di proprietà di Simple Stickers e sono protetti da leggi internazionali sul diritto d'autore, marchi commerciali, brevetti, segreti commerciali e altre leggi sulla proprietà intellettuale.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Limitazione di Responsabilità</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Nella misura massima consentita dalla legge applicabile, Simple Stickers non sarà responsabile per danni indiretti, incidentali, speciali, consequenziali o punitivi, inclusi, senza limitazione, perdita di profitti, dati, utilizzo, avviamento o altre perdite immateriali, derivanti dal tuo utilizzo del servizio.
                </p>
                <p className="leading-relaxed">
                  Questa limitazione di responsabilità non si applica ai danni causati da dolo o colpa grave, o come altrimenti vietato dalla legge applicabile.
                </p>
                <p className="leading-relaxed">
                  La nostra responsabilità totale nei tuoi confronti per qualsiasi reclamo derivante dal tuo utilizzo del servizio non supererà l'importo che ci hai pagato nei 12 mesi precedenti il reclamo, o €100, a seconda di quale sia maggiore.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Risoluzione</h2>
              <p className="leading-relaxed">
                Possiamo terminare o sospendere il tuo account e bloccare l'accesso al servizio immediatamente, senza preavviso o responsabilità, a nostra esclusiva discrezione, per qualsiasi motivo, incluso, senza limitazione, se violi i Termini.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Modifiche ai Termini</h2>
              <p className="leading-relaxed">
                Ci riserviamo il diritto di modificare o sostituire questi Termini in qualsiasi momento. Se una revisione è sostanziale, forniremo almeno 30 giorni di preavviso prima che i nuovi termini entrino in vigore.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">17. Informazioni di Contatto</h2>
              <div className="space-y-4">
                <p className="leading-relaxed">
                  Se hai domande su questi Termini di Servizio, contattaci:
                </p>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm text-gray-700">
                    <strong>Email:</strong> support@simplestickers.app
                  </p>
                  <p className="text-xs text-gray-500 mt-2">
                    Per tutte le richieste riguardanti supporto, questioni legali, privacy, protezione dei dati e domande commerciali
                  </p>
                </div>
              </div>
            </section>
          </div>
        </article>
      </div>
    </div>
  );
}
